module.exports = __webpack_public_path__ + "img/TZS09681.52e09cc6.jpeg";